module.exports = __webpack_public_path__ + "assets/nexo.cf35bd0b.jpg";